export const status = {
    idle: 'idle',
    loading: 'loading',
    finished: 'finished',
    error: 'error'
}